import { render, staticRenderFns } from "./stat-card.generic.vue?vue&type=template&id=6b2e66e4&"
import script from "./stat-card.generic.vue?vue&type=script&lang=js&"
export * from "./stat-card.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports